import { _Set } from '../../utils/lang/sets';
/**
 * Extract whitelist as a set. Used by 'WHITELIST' matcher.
 */
export function whitelistTransform(whitelistObject) {
    return new _Set(whitelistObject.whitelist);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio-commons/esm/evaluator/matchersTransform/whitelist.js
// module id = 3868
// module chunks = 25